<script>
	// import Image from "./Image.svelte";

    export let header = {
        label:"",
        fontSize: "1rem"
    };
    export let text = {
        label:"",
        fontSize: "1rem"
    };
    export let fontColor = 'var(--color-text)';
    export let image = '';
    export let bg = '';
    export let bgMob = '';
    export let reverse = false;
    export let bgType = 'box';
    export let imageAriaHidden = false;
    export let classList = '';
    export let bgFallback = 'none';
    export let headerTag = 'h2';
     /**
	 * @type {string | undefined}
	 */
      export let imageWebp = undefined;
</script>

<div 
    class="category {classList}"
    style:--bg-wrap={bgType == 'fill' ?  'url('+ bg +')' : 'none' }
    style:--bg-wrap-mob={bgType == 'fill' ?  'url('+ bgMob +')' : 'none' }
>
    <div 
        class="container" 
    >
        <div 
            class="category__wrap"
            style:--bg={bgType == 'box' ? 'url('+ bg +')' : 'none' }
            style:--bg-mob={bgType == 'box' ? 'url('+ bgMob +')' : 'none' }
            class:reverse
            style:background-color={bgFallback}
            style:color={fontColor}
        >
            <div class="category__text">
                <svelte:element this={headerTag} class="category__h2">{header.label}</svelte:element>
                <p class="category__p">{text.label}</p>
                <slot name="afterText" />
            </div>
            <div class="category__imageWrap">
                <slot name="image">
                    <!-- <Image src={image} alt={header.label} className="category__img" /> -->
                    <picture>
                        {#if imageWebp}
                            <source srcset={imageWebp} type="image/webp">
                        {/if}
                        <img 
                            class="category__img" 
                            src={image} alt={header.label}
                            loading="lazy"
                            draggable="false"
                            decoding="async"
                            aria-hidden={imageAriaHidden}
                        >
                    </picture>
                </slot>
            </div>
        </div>
    </div>
</div>

<style lang="postcss">
    .textTop{
        & .category__text{
            order: -1;
            margin: * * 1rem;
        }
        & .category__imageWrap{
            order: 1;
        }
    }
    .textBottom{
        & .category__text{
            order: 1;
        }
        & .category__imageWrap{
            order: -1;
            margin: * * 2.875rem;
        }
    }
    .bg .category__wrap{
        padding: 3.75rem;
    }
    .category{
        background-position: 0 0;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: var(--bg-wrap-mob);

        &{
            @media (max-width:1279px) {
                background-image: none!important;
            }
        }
        & :global(.category__img){
            size: 15.8333rem;
            object-fit: contain;
        }
    }
    .category__wrap{
        background-position: 100% 100%;
        display: flex;
        flex-wrap: wrap;
        background-size: cover;
        background-repeat: no-repeat;
        background-image: var(--bg-mob);
        border-radius: 0.83rem;
        justify-content: stretch;
        margin: * * 1.67rem;

        &.reverse{
            flex-direction: row-reverse;
        }
    }
    .category__text{
        display: flex;
        flex-direction: column;
        flex: 22.92rem 1 1;
        align-items: center;
    }
    .category__imageWrap{
        display: flex;
        align-items: center;
        justify-content: center;
        margin: * auto;
        flex: 23rem 1 1;
    }
    .category__h2{
        margin: 0 *;
        font-size: 1.25rem;
        max-width: 21.4rem;
        width: 100%;
    }
    .category__p{
        margin: 0.5833rem * 0.8333rem;
        white-space: pre-wrap;
        max-width: 21.4rem;
    }
    @media (min-width: 540px){
        .category{
            background-image: var(--bg-wrap);
        }
        .category__text{
            align-items: flex-start;
        }
        .bg .category__wrap{
            background-image: var(--bg);
            padding: 0;
            padding: * 1.25rem;
        }
        .textTop, .textBottom{
            & .category__text, & .category__imageWrap{
                order: initial;
            }
        }
        .category__wrap{
            flex-wrap: nowrap;
            background-position: 0 100%;

            &.reverse{
                background-position: 100% 0;
            }
        }
        .category__text{
            margin: 5.25rem * 3.34rem;
            padding: 0.1667rem * * *;
        }

        .textTop, .textBottom{
            & .category__imageWrap, & .category__imageWrap{
                margin: 0;
            }
        }
    }
    @media (min-width: 768px){
        .bg .category__wrap{
            padding: * 4.58rem;
        }
        .category__h2{
            font-size: 1.67rem;
        }
        .category:not(.bg){
            .category__wrap:not(.reverse){
                .category__text{
                    padding-left: 4.6rem;
                }
            }
        }
    }
    @media (min-width: 992px){
        .category__p{
            font-size: 0.88rem;
        }
        .category__h2{
            font-size: 1.65rem;
        }
        .category__h2, .category__p{
            max-width: 22.92rem;
        }
    }
    /* a{
        color: inherit;
    } */
</style>